import { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Heading, Text } from '@wix/design-system';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common';
import { ReviewsMainHeaderProps } from '@components/Reviews/types';
import s from './ReviewsHeader.module.scss';

interface ReviewsHeaderProps extends ReviewsMainHeaderProps {}

const ReviewsHeader: FC<ReviewsHeaderProps> = ({
  title,
  isMobileView,
  reviewsCount,
  averageReviewRating,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <Box
      direction="horizontal"
      gap="SP2"
      marginBottom={isMobileView ? 'SP4' : 'SP5'}
    >
      {isMobileView ? (
        <Heading size="medium" as="h2" dataHook="reviews-header">
          {t(title)}
        </Heading>
      ) : (
        <Text as="h2" size="medium" weight="bold" dataHook="reviews-header">
          {t(title)}
        </Text>
      )}

      <Box verticalAlign="middle" gap="3px">
        <FavoriteFilledSmall />
        <Text as="span" size="medium" weight="bold">
          {Intl.NumberFormat(language, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }).format(averageReviewRating)}
        </Text>
        <Text as="span" size="medium" weight="normal" className={s.textColor}>
          ({reviewsCount})
        </Text>
      </Box>
    </Box>
  );
};

export default ReviewsHeader;
